import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getContentLanguages = api(async function getContentLanguages() {
    return query(
        gql`
            query GetContentLanguages {
                getContentLanguages {
                    _id
                    code
                    name
                    nativeName
                    rtl
                }
            }
        `,
        {},
        { returns: "getContentLanguages" }
    )
})
